import { ComponentStyleConfig } from "@chakra-ui/react";

const TopicSelector: ComponentStyleConfig = {
	baseStyle: ({ isCurrent, color }) => {
		return {
			wrapper: {
				bg: "white",
				width: "100vw",
				display: "flex",
				flexDir: "column",
				alignItems: "center",
				padding: 8,
				gap: 6,
				color: "brand.blue",
			},
			buttonWrapper: {
				display: "flex",
				flexDir: { base: "column", sm: "row" },
				flexWrap: "wrap",
				justifyContent: "center",
				gap: 6,
			},
			button: {
				borderWidth: "2px",
				borderRadius: "xl",
				boxShadow: "drop",
				bg: isCurrent ? color : "none",
				color: isCurrent ? "white" : "brand.blue",
				borderColor: isCurrent ? color : "brand.blue",
				_hover: {
					bg: color,
					borderColor: color,
					color: "white",
				},
			},
		};
	},
};

export default TopicSelector;
